import type { CreateExchangeTransferRequest } from '@dynamic-labs/sdk-api-core';
import { ExchangeKeyEnum } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../../client/core/getCore';
import { getDefaultClient } from '../../../../client/defaultClient';
import { createApiClient } from '../../../apiClient';
import type { ExchangeTransferResponse } from '../kraken.types';

// Kraken transfer request includes accountId + transfer parameters
export type KrakenTransferRequest = CreateExchangeTransferRequest & {
  /**
   * The Kraken account ID to transfer from (get from getKrakenAccounts)
   */
  accountId: string;
};

/**
 * Creates a Kraken exchange transfer to send crypto from a Kraken account to a whitelisted address
 *
 * @param transferParams - The parameters for the transfer including accountId
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns The created transfer
 */
export const createKrakenExchangeTransfer = async (
  transferParams: KrakenTransferRequest,
  client = getDefaultClient()
): Promise<ExchangeTransferResponse> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  const { accountId, ...createExchangeTransferRequest } = transferParams;

  const response = await apiClient.postExchangeAccountTransfer({
    accountId,
    createExchangeTransferRequest,
    environmentId: core.environmentId,
    exchangeKey: ExchangeKeyEnum.Kraken,
  });

  return response;
};
